import styled from '@emotion/styled';

export const DirectBookContainer = styled.div`
  // targetted overrides due to differences in PMC styling context affecting positioning
  // these are for the apptTime step of @kyruus/direct-book-widget

  ${(props) => {
    if (props.jumpToDateEnabled === true) {
      return `
        .GroupedAppts__header {
          top: 249px;
      
          @media screen and (min-width: 314px) {
            top: 207px;
          }
      
          @media screen and (min-width: 420px) {
            top: 179px;
          }
      
          @media screen and (min-width: 545px) {
            top: 134px;
          }
      
          @media screen and (min-width: 993px) {
            top: 193px;
          }
      
          @media screen and (min-width: 1097px) {
            top: 148px;
          }
        }
      
        .GroupedAppts__Group__header {
          top: 296px;
      
          @media screen and (min-width: 314px) {
            top: 254px;
          }
      
          @media screen and (min-width: 420px) {
            top: 226px;
          }
      
          @media screen and (min-width: 545px) {
            top: 181px;
          }
      
          @media screen and (min-width: 993px) {
            top: 240px;
          }
      
          @media screen and (min-width: 1097px) {
            top: 195px;
          }
        }
      `;
    }

    return `
      .GroupedAppts__header {
        top: 62px;

        @media screen and (min-width: 993px) {
          top: 84px;
        }
      }

      .GroupedAppts__Group__header {
        top: 109px;

        @media screen and (min-width: 993px) {
          top: 131px;
        }
      }
    `;
  }}
`;
